<!-- <div #mask [ngClass]="{'p-dialog-mask':true, 'p-component-overlay p-component-overlay-enter p-dialog-mask-scrollblocker': config.modal !== false}">
<div [ngClass]="{'p-dialog p-dynamic-dialog p-component':true}" [ngStyle]="config.style" [class]="config.styleClass"
  [@animation]="{value: 'visible', params: {transform: transformOptions, transition: config.transitionOptions || '150ms cubic-bezier(0, 0, 0.2, 1)'}}"
  (@animation.start)="onAnimationStart($event)"
  (@animation.done)="onAnimationEnd($event)" role="dialog" *ngIf="visible"
  [style.width]="config.width" [style.height]="config.height">

  <div class="p-dialog-header" *ngIf="config.showHeader === false ? false: true">
    <span class="p-dialog-title">{{config.header}}</span>
    <div class="p-dialog-header-icons">
      <button [ngClass]="'p-dialog-header-icon p-dialog-header-maximize p-link'" type="button" (click)="hide()" (keydown.enter)="hide()" *ngIf="config.closable !== false">
        <span class="p-dialog-header-close-icon fa fa-times"></span>
      </button>
    </div>
  </div>

  <div class="p-dialog-content" [ngStyle]="config.contentStyle">

  </div>

  <div class="p-dialog-footer" *ngIf="config.footer">
    {{config.footer}}
  </div>
</div>
</div> -->


<div class="modal-content">
  @switch (contentType) {
    @case ('string') {
      <div class="box">
        <div [innerHTML]="content"></div>
      </div>
    }
    @case ('template') {
      <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
    }
    @case ('component') {
      <ng-container *ngComponentOutlet="content"></ng-container>
    }
  }
</div>

<!-- <button (click)="close()" class="modal-close is-large" aria-label="close">CLOSE</button> -->